export default __webpack_public_path__ + "static/media/bg.76d70fdf.jpg";